import React from 'react'
import { ClockingsFilters, FiltersResourcesEnum } from '../../store/filters'
import useFilters from '../../hooks/filters'
import { Field, Formik } from 'formik'
import { Columns } from 'react-bulma-components'
import AutoSubmit from '../form/utils/auto-submit'
import WorkersFilterField from '../filters/fields/workers'
import DateFilterField from '../filters/fields/date'
import { dateInputToDateValue, dateToDateInputValue } from '../../utils/date'
import { endOfDay, startOfDay } from 'date-fns'
import FiltersWrapper from '../filters/filters-wrapper'
import FieldColumn from '../filters/field-column'
import MultiSelectField from '../form/fields/multi-select'
import { ClockingStatusEnum } from '../../utils/clockings'

const ClockingsFilters: React.FC = ({}) => {
  const { setFilters, filters } = useFilters(FiltersResourcesEnum.clockings)

  return (
    <Formik<ClockingsFilters & { date: string }>
      initialValues={{
        ...filters,
        date: dateToDateInputValue(filters.start ? new Date(filters.start) : new Date()),
      }}
      onSubmit={values => {
        if (values.date) {
          const dayDate = dateInputToDateValue(values.date)
          values = {
            ...values,
            start: startOfDay(dayDate),
            end: endOfDay(dayDate),
          }
        }
        setFilters(FiltersResourcesEnum.clockings, values)
      }}
    >
      {props => {
        return (
          <FiltersWrapper resource={FiltersResourcesEnum.clockings}>
            <Columns mb="0">
              <DateFilterField name="date" label="Jour" data-test="clockings-date-filter" />
              <WorkersFilterField />
              <FieldColumn>
                <Field
                  label="Type"
                  name="type"
                  component={MultiSelectField}
                  data-test="clockings-type-filter"
                  options={Object.values(ClockingStatusEnum).map(value => ({
                    value,
                    label: value,
                  }))}
                />
              </FieldColumn>
            </Columns>
            <AutoSubmit values={props.values} submitForm={props.submitForm} />
          </FiltersWrapper>
        )
      }}
    </Formik>
  )
}

export default ClockingsFilters
